import {
  selectCitiesCache,
  selectCurrentPlayer,
  selectPlayers,
  selectSharedGameState
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {getActingPlayerFromState} from "../../players/getActingPlayer";
import {
  checkIfParallelSupplyPhase,
  checkIfPlayerCompletedPhase,
  getFirstNotCompletedPlayer
} from "./parallelSupply";

const EMPTY_CITIES = [];

/** Идет ли сейчас одновременная фаза снабжения (см. parallelSupply) */
export const selectIsParallelSupplyPhase = (state) => checkIfParallelSupplyPhase(selectSharedGameState(state));

/**
 * Игрок партии, за которого ЭТОТ клиент сейчас раздает снабжение.
 *
 * В одновременной фазе — действующий игрок пользователя (он сам или бот,
 * которым он управляет как админ), пока тот не закончил свою часть фазы; у
 * зрителя, записи матча и закончившего игрока — null (раздавать нечего).
 * Вне одновременной фазы — текущий игрок, как всегда было.
 *
 * Все, что в фазе снабжения считает фермы, пути, остатки и отложенное
 * снабжение «за игрока», берет игрока отсюда, а не из selectCurrentPlayer
 */
export const selectSupplyActingPlayer = (state) => {
  const gameState = selectSharedGameState(state);
  if (!checkIfParallelSupplyPhase(gameState)) {
    return selectCurrentPlayer(state);
  }
  const actingPlayer = getActingPlayerFromState(state);
  const isGamePlayer = Boolean(actingPlayer)
    && (selectPlayers(state) || []).some((player) => player.id === actingPlayer.id);
  if (!isGamePlayer || checkIfPlayerCompletedPhase(gameState, actingPlayer.id)) {
    return null;
  }
  return actingPlayer;
};

/** Города игрока из selectSupplyActingPlayer (пустой список, если его нет) */
export const selectSupplyActingPlayerCities = (state) => {
  const player = selectSupplyActingPlayer(state);
  if (!player) {
    return EMPTY_CITIES;
  }
  return selectCitiesCache(state)?.[player.color] || EMPTY_CITIES;
};

/**
 * Чей ход показывать (кнопка завершения хода, статы в шапке, цвет рамки).
 *
 * В одновременной фазе снабжения — сам пользователь, пока он не закончил свою
 * часть; после этого (и у зрителя, и в записи матча) — первый в порядке хода
 * еще не закончивший игрок, чтобы все клиенты показывали одного и того же.
 * Вне одновременной фазы — текущий игрок
 */
export const selectTurnDisplayedPlayer = (state) => {
  const gameState = selectSharedGameState(state);
  if (!checkIfParallelSupplyPhase(gameState)) {
    return selectCurrentPlayer(state);
  }
  return selectSupplyActingPlayer(state)
    || getFirstNotCompletedPlayer(gameState)
    || selectCurrentPlayer(state);
};
